<template>
    <header class="sticky top-0 left-0 right-0 bg-white p-6 z-30 justify-center flex min-h-[80px]">
        <div class="flex justify-between items-center container">
            <div class="w-32 md:w-auto" id="logo">
                <img class="-translate-y-[4px]" :src="global.app.url + 'images/logo-dark.svg'" alt="Options Desk logo" title="Options Desk" />
                <router-link class="ml-0 md:ml-12 no-underline text-deep-blue" :to="{ name: 'admin-dashboard'}">Dashboard</router-link>
            </div>
            <nav class="menu-container">
                <!-- Just a simple logout button for now -->
                <span v-if="user != undefined && user.access_token" class="cursor-pointer" @click="handleLogout()">
                    Log out
                </span>
            </nav>
        </div>
    </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "HeaderComponent",
    components: {},
    computed: {
        ...mapGetters(["global", "user"]),
    },
    data: function () {
        return {
            isLoading: false,
        };
    },
    methods: {
        ...mapActions(["doLogout"]),
        handleLogout() {
            this.doLogout().then((response) => {
                this.$router.go({ name: "login" });
            });
        },
    },
};
</script>
